/**
 * @description Internal UserType resolved from paramsVO.USER.userStatus
 * and used for internal user type related use cases
 */
export enum UserType {
	/**
	 * @description Anonymous user, possible values: sb|0, anon
	 */
	ANON = 'ANON',

	/**
	 * @description Limited Commercial user
	 */
	LC = 'LC',

	/**
	 * @description Commercial Free user
	 */
	CF = 'CF',

	/**
	 * @description Low Cost Plan user
	 */
	LCP = 'LCP',

	/**
	 * @description MVPD Authenticated user from P+ Domestic or Intl
	 */
	MVPD_AUTHZ = 'MVPD_AUTHZ',

	/**
	 * @description MVPD Authenticated user from CBS TVE Domestic
	 */
	MVPD_AUTHZ_TVE = 'MVPD_AUTHZ_TVE',
}